export default {
  name: 'EplNewCustomPay',
  props: [],
  data () {
    return {
      amount: ''
    }
  },
  methods: {
    initiatePayment () {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "REPAYMENT_OPTION_SELECTED",
        propertyName: "AMOUNT",
        propertyValue: this.amount
      });
      localStorage.setItem('txnAmount', this.amount)
      this.$store.commit('setPaymentAmount', this.amount)
      this.$router.push({ name: 'Payment' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/EplNewPayCustom/component.js